import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import {
  FORGOT_ADMIN_USER_PASSWORD,
  RESET_ADMIN_USER_PASSWORD,
  UPDATE_ADMIN_USER_PASSWORD,
} from "./actionTypes"
import {
  resetAdminUserPasswordSuccess,
  resetAdminUserPasswordError,
  forgotAdminUserPasswordSuccess,
  forgotAdminUserPasswordError,
  updateAdminUserPasswordSuccess,
  updateAdminUserPasswordError,
} from "./actions"

import { AppConfiguration } from "config"

//Include Both Helper File with needed methods
import { postJwtForgetPwd, postJwtResetPwd, postJwtUpdatePwd } from "helpers/sf_backend_helper"
import {
  RESET_PWD_ERROR_PREVIOUS_PASSWORD,
} from "common/sf_strings"
import { capitalize } from "lodash"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* adminPasswordReset({ payload: { user, history } }) {
  try {
    if (AppConfiguration.DEFAULT_AUTH === "jwt") {
      const response = yield call(
        postJwtResetPwd,
        `${AppConfiguration.BACKEND_URL}/api/v1/admin_password`,
        {
          email: user.email,
          reset_password_token: user.reset_password_token,
          password: user.password,
          password_confirmation: user.password_confirmation,
        }
      )
      yield put(resetAdminUserPasswordSuccess("Password Changed Successfully"))
    }
    history.push("/login?flash_message_type=success&flash_message_text=Password Reset successful, please login to proceed.")
  } catch (error) {
    let reset_pwd_error =
      "Reset Password Failed. Please check the link or try again..."
    if (error.localeCompare(RESET_PWD_ERROR_PREVIOUS_PASSWORD) === 0) {
      reset_pwd_error =
        capitalize(RESET_PWD_ERROR_PREVIOUS_PASSWORD) + " Please try another..."
    }
    yield put(resetAdminUserPasswordError(reset_pwd_error))
  }
}

function* OnForgotAdminPassword({ payload: { user, history } }) {
  try {
    const response = yield call(
      postJwtForgetPwd,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_password`,
      {
        email: user.email,
      }
    )
    if (response) {
      yield put(
        forgotAdminUserPasswordSuccess("Reset link is sent to your mailbox.")
      )
    }
  } catch (error) {
    yield put(forgotAdminUserPasswordError(error))
  }
}

function* OnUpdateAdminPasseword(action) {
  try {
    let user_auth = bsh_getAdminUserDetails();

    const response = yield call(
      postJwtUpdatePwd,
      `${AppConfiguration.BACKEND_URL}/api/v1/admin_password`,
      {
        password: action.payload.password,
        current_password: action.payload.current_password,
        token: user_auth.token,
      }
    )
    yield put(updateAdminUserPasswordSuccess("Password Changed Successfully"))
  } catch (error) {
    yield put(updateAdminUserPasswordError(error))
  }
}

function* ResetAdminPasswordSaga() {
  yield takeEvery(RESET_ADMIN_USER_PASSWORD, adminPasswordReset)
  yield takeEvery(FORGOT_ADMIN_USER_PASSWORD, OnForgotAdminPassword)
  yield takeEvery(UPDATE_ADMIN_USER_PASSWORD, OnUpdateAdminPasseword)
}

export default ResetAdminPasswordSaga
